import script from "./ChaDsVasScore.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChaDsVasScore.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__